import './Header.css';

const Header = () => (
  <div className="fw-400 ff-ns">
    <h1 className="my-box-page-title mar-0 pad-0 ff-pds fw-nor">My Subscriptions</h1>
    <div className="hor-rule" />
  </div>
);

export default Header;
